import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  CanActivateChild,
} from '@angular/router';

import { NavController } from '@ionic/angular';

import { map, Observable, withLatestFrom } from 'rxjs';

import { DawbaRoutes } from '../route-constants';
import { DawbaAppService } from '../services/app.service';

@Injectable()
export class SdqCompletedRouteGuard implements CanActivateChild {
  constructor(
    private dawbaService: DawbaAppService,
    private navCtrl: NavController
  ) {}

  canActivate(
    _route: ActivatedRouteSnapshot,
    _state: RouterStateSnapshot
  ): Observable<boolean> {
    return this.dawbaService.isCarePlanLoaded$.pipe(
      withLatestFrom(this.dawbaService.carePlan$),
      map(([loaded, dawbaCarePlan]) => {
        console.log({ loaded, dawbaCarePlan });
        const completed = dawbaCarePlan.sdqActivity.status === 'completed';
        if (!completed) {
          this.navCtrl.navigateRoot(DawbaRoutes.IntroToSsdqPage);
        }
        return completed;
      })
    );
  }

  canActivateChild(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> {
    return this.canActivate(route, state);
  }
}

@Injectable()
export class SdqNotCompletedRouteGuard implements CanActivateChild {
  constructor(
    private dawbaService: DawbaAppService,
    private navCtrl: NavController
  ) {}

  canActivate(
    _route: ActivatedRouteSnapshot,
    _state: RouterStateSnapshot
  ): Observable<boolean> {
    return this.dawbaService.isCarePlanLoaded$.pipe(
      withLatestFrom(this.dawbaService.carePlan$),
      map(([loaded, dawbaCarePlan]) => {
        console.log({ loaded, dawbaCarePlan });
        const completed = dawbaCarePlan.sdqActivity.status === 'completed';
        if (completed) {
          this.navCtrl.navigateRoot(DawbaRoutes.DashboardPage);
        }
        return !completed;
      })
    );
  }

  canActivateChild(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> {
    return this.canActivate(route, state);
  }
}
